"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFile = fetchFile;
exports.fetchFileAsync = fetchFileAsync;
exports.setUserAgent = setUserAgent;
exports["default"] = void 0;

var _syncFetch = _interopRequireDefault(require("sync-fetch"));

require("isomorphic-fetch");

var _logger = _interopRequireDefault(require("../logger"));

var _package = require("../../package.json");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var corsEnabled = typeof location !== 'undefined' && typeof document !== 'undefined';
var userAgent = "Citation.js/".concat(_package.version, " Node.js/").concat(process.version);

function normaliseHeaders(headers) {
  var result = {};
  var entries = headers instanceof Headers || headers instanceof _syncFetch["default"].Headers ? Array.from(headers) : Object.entries(headers);

  var _iterator = _createForOfIteratorHelper(entries),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          name = _step$value[0],
          header = _step$value[1];

      result[name.toLowerCase()] = header.toString();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

function parseOpts() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var reqOpts = {
    headers: {
      accept: '*/*'
    },
    method: 'GET',
    checkContentType: opts.checkContentType
  };

  if (userAgent && !corsEnabled) {
    reqOpts.headers['user-agent'] = userAgent;
  }

  if (opts.body) {
    reqOpts.method = 'POST';
    var isJson = typeof opts.body !== 'string';
    reqOpts.body = isJson ? JSON.stringify(opts.body) : opts.body;
    reqOpts.headers['content-type'] = isJson ? 'application/json' : 'text/plain';
  }

  if (opts.headers) {
    Object.assign(reqOpts.headers, normaliseHeaders(opts.headers));
  }

  return reqOpts;
}

function sameType(request, response) {
  if (!request.accept || request.accept === '*/*' || !response['content-type']) {
    return true;
  }

  var _response$contentTyp = response['content-type'].split(';')[0].trim().split('/'),
      _response$contentTyp2 = _slicedToArray(_response$contentTyp, 2),
      a = _response$contentTyp2[0],
      b = _response$contentTyp2[1];

  return request.accept.split(',').map(function (type) {
    return type.split(';')[0].trim().split('/');
  }).some(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        c = _ref2[0],
        d = _ref2[1];

    return (c === a || c === '*') && (d === b || d === '*');
  });
}

function checkResponse(response, opts) {
  var status = response.status,
      headers = response.headers;
  var error;

  if (status >= 400) {
    error = new Error("Server responded with status code ".concat(status));
  } else if (opts.checkContentType === true && !sameType(opts.headers, normaliseHeaders(headers))) {
    error = new Error("Server responded with content-type ".concat(headers.get('content-type')));
  }

  if (error) {
    error.status = status;
    error.headers = headers;
    error.body = response.body;
    throw error;
  }

  return response;
}

function fetchFile(url, opts) {
  var reqOpts = parseOpts(opts);

  _logger["default"].http('[core]', reqOpts.method, url, reqOpts);

  var response = checkResponse((0, _syncFetch["default"])(url, reqOpts), reqOpts);
  return response.text();
}

function fetchFileAsync(_x, _x2) {
  return _fetchFileAsync.apply(this, arguments);
}

function _fetchFileAsync() {
  _fetchFileAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, opts) {
    var reqOpts;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reqOpts = parseOpts(opts);

            _logger["default"].http('[core]', reqOpts.method, url, reqOpts);

            return _context.abrupt("return", fetch(url, reqOpts).then(function (response) {
              return checkResponse(response, reqOpts);
            }).then(function (response) {
              return response.text();
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchFileAsync.apply(this, arguments);
}

function setUserAgent(newUserAgent) {
  userAgent = newUserAgent;
}

var _default = fetchFile;
exports["default"] = _default;